export default "__VITE_PUBLIC_ASSET__02460434__"